<form class="delete-reason-page" [formGroup]="form">
  <div class="delete-reason-page__close" (click)="close()">
    <i class="fsi fsi-close"></i>
  </div>

  <div class="delete-reason-page__icon">
    <i class="fsi fsi-circle-equals"></i>
  </div>

  <div class="delete-reason-page__title">{{ data.title }}</div>
  <div formArrayName="checkboxes" class="checkboxes-wrapper">
    @for (reason of reasons; track reason; let i = $index) {
      <div>
        <div class="checkbox-container">
          <div class="checkbox-container__payload">
            <input
              type="checkbox"
              #checkbox
              [formControlName]="i"
              [id]="reason.code"
              (change)="onCheckboxChange($event.target.checked, reason)" />
            <label class="pseudo-input" [for]="reason.code"></label>
            <label [for]="reason.code">
              <span class="reason__title">{{ reason.value }}</span>
            </label>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="footer">
    <textarea
      formControlName="comment"
      class="docs__note"
      [placeholder]="notePlaceholder"></textarea>
    <div class="delete-reason-page__actions">
      <button
        class="btn primary-button"
        (click)="onSubmit()"
        [class.disabled]="isButtonDisabled">
        Подтвердить
      </button>
    </div>
  </div>
</form>
